var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-view',{key:_vm.rerender,on:{"rerender":function($event){_vm.rerender = !_vm.rerender}}})
}
var staticRenderFns = []

export { render, staticRenderFns }